import React from "react";

import { SkeletonBar } from "components/skeleton";

interface IStatisticsBarFiltersSkeletonProps {
  count: number;
}

export default function StatisticsBarFiltersSkeleton(props: IStatisticsBarFiltersSkeletonProps) {
  if (props.count <= 0) {
    return null;
  }

  return (
    <>
      {Array.from({ length: props.count }).map((_, index) => (
        <div key={index} className="statistics-bar-filter statistics-bar-filter-skeleton">
          <SkeletonBar className="statistics-bar-filter-skeleton-bar" height="2.5rem" />
        </div>
      ))}
    </>
  );
}
